import React, { useState, useReducer, useEffect } from "react"
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  CircularProgress,
  MenuItem,
  Select,
  Alert
} from "@mui/material"
import GridFiles from "components/Common/GridFilesAnt"
import FilePondUpload from "components/Common/FilePondUpload"
import { getCurrentUser, enumToArray } from "helpers/service_helper"
import { FileGasProjectType } from "models/types/file-gas-project-type"
import { Modal } from "antd"

export const ProjectFiles = ({ rowData, mainProps, setErrorMessage }) => {
  const { lstGasProjectFiles } = mainProps
  const style = {
    // border: "2px solid #000",
    p: 2,
  }
  const [files, setFiles] = useState([])
  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      idGasProject: rowData.row.id,
      fileTypeEnum: 2
    }
  )
  const [open, setOpen] = useState(false)
  const [fileGasProjectTypes, setFileGasProjectTypes] = useState([])
  useEffect(() => {
    setFileGasProjectTypes(enumToArray(FileGasProjectType))
  }, [])

  const handleInput = evt => {
    const name = evt.target.name
    const newValue = evt.target.value
    setFormInput({ [name]: newValue })
  }
  const saveToDatabase = async (values) => {
    const { onAddFileGasProjectSingle } = mainProps
      let file = files[0].file
     const fileName = FileGasProjectType[values.fileTypeEnum]
      let formData = new FormData()
      formData.append("file", file, fileName + "." + file.name.split('.')[file.name.split('.').length-1])
      formData.append("gasProjectId", JSON.stringify([values.idGasProject]))
      formData.append("name","gas-" + fileName)
      formData.append("des", `Upload with-${getCurrentUser().sid}`)
      formData.append("fileTypeEnum",fileName)
      formData.append("FolderName", "GasProjects")
      formData.append("FileName", fileName + "." + file.name.split('.')[file.name.split('.').length-1])
      formData.append("userId", getCurrentUser().sid)
      formData.append("toUserId", getCurrentUser().sid)
     await onAddFileGasProjectSingle(formData)
  }
  const handleSubmitForm = async (event, values) => {
    event.preventDefault()

    if (formInput.idGasProject.length !== 0 && files[0]) {
    await saveToDatabase(formInput)
    // await onGetProjectFiles(formInput.idGasProject)
    }else {
      setErrorMessage("برای ذخیره ابتدا فایل را برگذاری کنید")
    }
  }
  return (
    <Box>
      <Button
        variant="contained"
        color="primary"
        size="small"
        style={{}}
        onClick={async () => {
          const { onGetProjectFiles } = mainProps

          await onGetProjectFiles(rowData.row.id)

          setOpen(!open)
        }}
      >
        فایلها
      </Button>

      <Modal
        open={open}
        title={"مدیریت فایل های پرونده:" + rowData.row.fileNumber + "مالک:" + rowData.row.landlordName}
        onCancel={() => setOpen(false)}
        onClose={() => {
          setOpen(false)
        }}
                
        footer={null}
      >
        <form onSubmit={handleSubmitForm}>
          <DialogContent>
            <Grid item xs={12}>
                {mainProps.error ? (
                  <Alert severity="error">{mainProps.error}</Alert>
                ) : null}
                {mainProps.success ? (
                  <Alert severity="success">{mainProps.success}</Alert>
                ) : null}
              </Grid>
            <Box sx={{ ...style }}>
              <GridFiles lstGasProjectFiles={lstGasProjectFiles} props={mainProps} />
            </Box>
            {(rowData.row.projectLevelEnum !== 2  || getCurrentUser().role ==='Administrator') && <Box>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                
                  <FormControl size="small" fullWidth>
               
                    <InputLabel id="select-label-fileTypeEnum">
                      نوع فایل
              
                    </InputLabel>
                    <Select
                      labelId="select-label-fileTypeEnum"
                      name="fileTypeEnum"
                      value={
                        formInput.fileTypeEnum ? formInput.fileTypeEnum : 2
                      }
                      label="نوع فایل"
                      onChange={handleInput}
                    >
                      {fileGasProjectTypes &&
                        fileGasProjectTypes.map(row => {
                          if (row.id !== 0 && row.id !== 3  && row.id !==5 && row.id !== 6  ) {
                            return (
                              <MenuItem key={row.id} value={row.id}>
                                {mainProps.t("enums." + row.name)}
                              </MenuItem>
                            )
                          }
                        })}
                    </Select>
                  </FormControl>
                </Grid>
                
                <Grid item xs={12}>
                <FilePondUpload
                  setFiles={setFiles}
                  maxFileSize="800KB"
                  allowMultiple={false}
                  maxFiles={1}
                  acceptedFileTypes={["image/png", "image/jpeg"]}
                  imagePreviewMaxHeight={600}
                  labelText={`${mainProps.t("enums." + FileGasProjectType[formInput.fileTypeEnum])} را اینجا بکشید`}
                  waterMark={false}
                />
              </Grid>
                
              </Grid>
            </Box>}
          </DialogContent>

          <DialogActions>
            <Box sx={{ display: "flex" }}>
              {mainProps.loading ? (
                <CircularProgress disableShrink />
              ) : (
                <Button disabled={rowData.row.projectLevelEnum === 2 && getCurrentUser().role !=='Administrator'} variant="contained" type="submit">
                  ذخیره
                </Button>
              )}
            </Box>
          </DialogActions>
        </form>
      </Modal>
    </Box>
  )
}
